import React from 'react';
import styled from 'styled-components';
import {
  ConfirmDialogComponent,
  MultiRecommendationComponent,
  RecommendationComponent } from '../../Recommendation';
import { QRGateway } from '../../QRGateway';
import Splashscreen from '../../Splashscreen/Splashscreen';
import { ErrorPanelStandalone } from '../Error';
import { Processing } from '../Processing';
import { FontsStyle } from '../../FontsStyle';
import { MeasurementComponent } from '../../Measurement';
import { InputSelection } from '../../InputSelection';
import { McGateway } from '../../McGateway';
import RenderUtil from '../../../util/RenderUtil';
import { EmailFormComponent, SuccessOutcomeComponent } from '../../EmailForm';

const ModalRoot = styled.div`
  display: none;
  position: fixed;
  z-index: 10000;
  left: 0;
  top: 0;
  width: 100%;
  height:100%;
  overflow: hidden;
  background-color: rgba(34, 34, 34, 0.75);
  justify-content: center;
  align-items: center;
  letter-spacing: normal;
  font-family: Inter, sans-serif;

  @media (pointer: fine), (pointer: none) {
  	/* desktop */
    height:100%;
  }

  @media (pointer: fine) and (any-pointer: coarse) {
  	/* touch desktop */
    height:100%;
  }

  &.fpt-modal--show {
    display: flex;
  }

  &.fpt-modal--hide {
    display: none;
  }

  /* Error view fullscreen styling */
  &.fpt-modal--error {
    background-color: #fff;
    align-items: flex-start;
  }

  & h1 {
    font-family: Inter, sans-serif;
    font-size: 30px;
    font-weight: 500;
    line-height: normal;
  }

  & p {
    line-height:24px;
  }
`;

const ModalContent = styled.div`
  color: #1e4e5f;
  text-align: center;
  width: 100%;

  @media (max-width: 600px) {
    max-width: 550px;
    box-shadow: none;
    border: none;
  }

  /* Error view should be fullscreen */
  &.fpt-modal__content--error {
    max-width: 100%;
    width: 100%;
    height: 100%;
  }
`;

const UndefinedView = () => { return (<></>)};

export enum ModalView {
  UNDEFINED,
  PROCESSING,
  SPLASHSCREEN,
  QR,
  RECOMMENDATION,
  ERROR,
  MULTI_RECOMMENDATION,
  FEEDBACK_CONFIRM,
  MEASUREMENT,
  INPUT_SELECTION,
  MC_GATEWAY,
  EMAIL_FORM,
  SUCCESS_OUTCOME,
}

const display = [
  UndefinedView,
  Processing,
  Splashscreen,
  QRGateway,
  RecommendationComponent,
  ErrorPanelStandalone,
  MultiRecommendationComponent,
  ConfirmDialogComponent,
  MeasurementComponent,
  InputSelection,
  McGateway,
  EmailFormComponent,
  SuccessOutcomeComponent,
];

export function Modal(props: any) {
  const { view, emitter, data, visible } = props;
  const isVisible = visible ? 'fpt-modal--show' : 'fpt-modal--hide';
  const DisplayComponent = display[view];
  const isMobile = RenderUtil.isMobile();

  // Add specific class for different views to target styling
  const getViewSpecificClass = () => {
    switch (view) {
      case ModalView.RECOMMENDATION:
        return 'fpt-modal__content--recommendation';
      case ModalView.ERROR:
        // Only apply fullscreen error styling on mobile
        return isMobile ? 'fpt-modal__content--error' : '';
      default:
        return '';
    }
  };
  const viewSpecificClass = getViewSpecificClass();

  // Error fullscreen styling only on mobile
  const isErrorViewMobile = view === ModalView.ERROR && isMobile;

  return (
    <ModalRoot className={`fpt-modal fpt-modal-gradient ${isVisible} ${isErrorViewMobile ? 'fpt-modal--error' : ''}`}>
      <FontsStyle />
      <ModalContent className={`fpt-modal__content ${viewSpecificClass}`}>
        <DisplayComponent emitter={emitter} {...data} />
      </ModalContent>
    </ModalRoot>
  );
}
